import { propagandeSectionContent, type PropagandeReview } from "../propagandeAssets";

function PropagandeQuote({ review }: { review: PropagandeReview }) {
  return (
    <>
      <blockquote>{review.quote}</blockquote>
      {review.url ? (
        <cite>
          <a className="remerciements-link" href={review.url} rel="noopener noreferrer" target="_blank">
            {review.source}
          </a>
        </cite>
      ) : (
        <cite>{review.source}</cite>
      )}
    </>
  );
}

export function PropagandeSection() {
  const { kicker, heading, intro, reviews } = propagandeSectionContent;

  return (
    <section className="section propagande-section" id="propagande">
      <div className="section-heading">
        <p className="kicker">{kicker}</p>
        <h2>{heading}</h2>
      </div>
      <div className="propagande-panel">
        <p className="propagande-intro">{intro}</p>
        <ul className="propagande-quotes">
          {reviews.map((review) => (
            <li className="propagande-quote" key={`${review.source}-${review.quote.slice(0, 32)}`}>
              <PropagandeQuote review={review} />
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
